import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { FormService } from 'src/app/services/form';
import { Router } from '@angular/router';
import { PEAssignment } from 'src/app/models/pe-assignment';
import { DataService } from 'src/app/services/data.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { SourceType } from 'src/app/models/sourcetype';
import { QueryAssignmentsForPEDTO } from 'src/app/models/internal/query-assignments-for-pe-dto';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { AppSettings } from 'src/app/app.settings';
import { Constants } from 'src/app/core/constants';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { NGXLogger } from 'ngx-logger';
import { UserDTO } from 'src/app/models/external/user-dto';
import { SioCode } from 'src/app/models/siocode';
import { TslMultiSelectSettings } from '@tesla/ng-tds';
import Helper from '../../../core/utility/helper';

/**
 * TMS-18339 Enhance PE assignment UI and process
 * Implement add new assignment page.
 */
@Component({
  selector: 'add-new-assignment',
  templateUrl: './add-new-assignment.component.html',
  styleUrls: ['./add-new-assignment.component.scss']
})
export class AddNewAssignmentComponent extends BaseGridPage implements OnInit, AfterViewInit {
  appSettings: AppSettings;
  peList: UserDTO[];
  peAssignmentsList: any[];
  sourceTypeList: SourceType[];
  partSystemList: PartSystemDTO[];
  sioCodeList: SioCode[];
  availablePartSystemList: PartSystemDTO[];
  sourceTypeId: number;
  partSystemId: number;
  searchSupplierURL: string;
  supplierAssginmentMessage: string = '';
  SIOCodeAssginmentMessage: string = '';
  @ViewChild('PEAutoComplete') PEAutoComplete: TeslaAutocompleteComponent;
  @ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;
  autoCompletePEURL: string;
  pe_addAssignmentForm: FormGroup;
  searchClicked = false;
  peAssignmentDTOList: PEAssignment[] = [];
  selectedSIOCodeList: SioCode[] = [];
  peAssignmentDTORequestList: PEAssignment[] = [];
  SioCodeSettings: TslMultiSelectSettings = {
    enableSearchFilter: true,
    noDataLabel: 'Search For Siocode',
    labelKey: 'Description',
    primaryKey: 'Id'
  }

  public formErrors = {
    PEId: '',
    SourceTypeId: '',
    PartCategoryId: '',
    SioCodeId: '',
    PartNumber: ''
  };

  constructor(
      private dataService: DataService,
      private fb: FormBuilder,
      private toastService: ToastService,
      public FormService: FormService,
      localstorageService: LocalstorageService,
      private spinnerService: SpinnerService,
      logger: NGXLogger,
      appSettings: AppSettings,
      private router: Router
    ) { 
      super(localstorageService, logger, appSettings);
        this.pe_addAssignmentForm = this.fb.group({
            PEId: [null, Validators.compose([Validators.required])],
            SourceTypeId: [null, Validators.compose([Validators.required])],
          PartCategoryId: [null, Validators.compose([Validators.required])],
            SupplierCode: [null, Validators.compose(null)], // optional filter
          SioCodeId: [null, Validators.compose(null)],
          PartNumber: [null, Validators.compose([
            Validators.maxLength(1200),
          ])]
        });

        this.appSettings = appSettings;
        this.autoCompletePEURL = this.appSettings.Packaging2APIUrl + '/peassignment/pe/all';
    this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';
  }

  ngOnInit() {
    this.initFilterValues(); 
    this.getAllPEs();
  }

  //tms-31828 show siocode dropdown without restricting it to select supplier code  
  initFilterValues(): void {
    this.filter = new SearchFilter();
    this.pe_addAssignmentForm.controls['PEId'].patchValue(null);
    this.getPartSystems();
    this.getSourceTypes();
    this.getSioCodes();
    this.fillGrid();
  }

  fillGrid(): void {
    this.filter.Skip = this.skip;
    this.filter.Take = this.pageSize;
    this.UpdateFilter();
    this.reloadAvailablePartSystems();
    this.resetSupplierCode();
  }

  //tms-32217 before add any assignment, check given combination exists in system using filters 
  addPEAssignment() {
    this.pe_addAssignmentForm.updateValueAndValidity({emitEvent: false, onlySelf: false});
    this.ValidateAddForm();
    if (this.pe_addAssignmentForm.valid && this.pe_addAssignmentForm.valid) {
      var supplierCode = this.getSupplierCode();
      this.UpdateFilter();
      // check if combination already exists
      const queryAssignmentsForPEDTO: QueryAssignmentsForPEDTO = new QueryAssignmentsForPEDTO();
      queryAssignmentsForPEDTO.SearchFilter = this.filter;
      queryAssignmentsForPEDTO.PEId = this.getPEId();
      queryAssignmentsForPEDTO.PartNumber = this.getPartNumber();
      queryAssignmentsForPEDTO.SupplierCode = supplierCode;
      queryAssignmentsForPEDTO.SioCodeId = this.getSioCode();

      this.dataService
        .getExistingAssignments(queryAssignmentsForPEDTO) 
          .subscribe((response: any) => {
            if (response && response.Success) {
                if (response.Data &&
                    response.Data.length) {
                    // The assignment combination already exists.
                  this.toastService.error(
                      'Given assignment combination already exist. Instead of creating a new assignment, please reassign.'
                  );
                } 
                else {
                    // The assignment combination does not exist, it is ok for addding a new assignment.
                    this.searchClicked = true; 

                  //tms-33944 create request model based on sio code selection 
                  this.createRequestModel();
                    this.dataService
                      .addPEAssignment(this.peAssignmentDTORequestList)
                        .subscribe((response: any) => {
                            if (response != null && response.Success) {
                                this.toastService.success('PE assignment added');
                            }
                            this.fillGrid();
                        });
                        
                  this.peAssignmentDTORequestList.length = 0;
                }
            }
      });
    }
  }

  reloadAvailablePartSystems() {
    // If the SourceTypeId is not null in pe_addAssignmentForm, update the part categories by the SourceTypeId.
    var sourceTypeIdInPEAddAssignmentForm = this.getSourceTypeId();
    if (sourceTypeIdInPEAddAssignmentForm) {
        this.dataService.getPartSystemsAvailableBySourceTypeId(sourceTypeIdInPEAddAssignmentForm).subscribe((response: any) => {
            if (response != null && response.Success) {
                this.availablePartSystemList = response.Data;
            }
        });
    }    
  }

  UpdateFilter() {        
    if (this.PEAutoComplete.list.length === 0) {
      this.pe_addAssignmentForm.controls['PEId'].patchValue(null);
    }

    this.pe_addAssignmentForm.clearValidators();
    this.filter.SearchFilterConditions = [];
    this.filter = this.setFilterCondition(this.filter, this.pe_addAssignmentForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
    this.filter = this.setFilterCondition(this.filter, this.pe_addAssignmentForm, 'PartCategoryId', Constants.FILTER_DATATYPE_NUMBER, Constants.FILTER_OPERATOR_TYPE_EQUAL);
  }

  clearFilter() {
    window.location.reload();
    this.reloadAvailablePartSystems();
  }

  getSourceTypes() {        
    this.dataService.getParentSourceTypes().subscribe((response: any) => {
        if (response != null && response.Success) {
            this.sourceTypeList = response.Data;
        }
    });
  }

  getPartSystems() {        
    this.dataService.getPartSystems().subscribe((response: any) => {
            if (response != null && response.Success) {
                this.partSystemList = response.Data;
            }
        });
  }

  getSioCodes() {        
    this.dataService.getSioCodes().subscribe((response: any) => {
      if (response != null && response.Success) {
        this.sioCodeList = response.Data;
      }
  });
  }

  onEmptySupplierCode(eventObj: any): void {
    this.pe_addAssignmentForm.controls['SupplierCode'].patchValue(null);
    this.SupplierAutoComplete.list = [];
    if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode') >= 0) {
        this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode'), 1);
    }
  }

  getPEId() {
    return this.pe_addAssignmentForm.controls['PEId'].value;
  }

  resetSupplierCode() {
    this.pe_addAssignmentForm.controls['SupplierCode'].patchValue(null);
  }

  getSourceTypeId() {
    return this.pe_addAssignmentForm.controls['SourceTypeId'].value;
  }

  getpartSystemId() {
    return this.pe_addAssignmentForm.controls['PartCategoryId'].value;
  }

  getSupplierCode() {
    return this.pe_addAssignmentForm.controls['SupplierCode'].value;
  }

  //tms-34809 extract siocode ids as a list as tsl-multiselect always returns object  
  getSioCode() {
    var siocode = this.pe_addAssignmentForm.controls['SioCodeId'].value;
    if (siocode != null) {
      const listofsiocodes = siocode.map(({ Id }) => Id);
      return listofsiocodes;
    }
    return siocode;
  }

  getPartNumber() {
    return this.pe_addAssignmentForm.controls['PartNumber'].value;
  }

  ValidateAddForm() {
    this.pe_addAssignmentForm.controls['PartNumber'].setErrors(null);
  const regex = /^[a-zA-Z,0-9\- ]+$/; // allow only letters number, dash, space and comma
    var partnumbers = this.getPartNumber();
    // fix partnumbers can be null so validate for value only if given
    if(Helper.isValidStringValue(partnumbers))
    {
    if(!regex.test(partnumbers))
    {
      this.pe_addAssignmentForm.controls['PartNumber'].setErrors({
        invalidPartNumberList: true,
    });
    };
    }
    this.formErrors = this.FormService.validateForm(
        <FormGroup>this.pe_addAssignmentForm,
        this.formErrors
    );
  }

  onEmptyPE(eventObj: any): void {
    this.PEAutoComplete.list = [];
  }

  sourceTypeChanged(event) {
    this.dataService.getPartSystemsAvailableBySourceTypeId(event).subscribe((response: any) => {
        if (response != null && response.Success) {
            this.availablePartSystemList = response.Data;
        }
    });
  }

  partSystemChanged(event) {


  }

  refreshToolTipText(code: string) {
    this.supplierAssginmentMessage = Constants[code];
    this.SIOCodeAssginmentMessage = Constants[code];
  }
  getSourceTypeName(id: number){
    if (id != null) {
        return this.sourceTypeList.find(x => x.Id === id).Description;
    }
    return '';
  
  }
  getPartSystemName(id: number){
    if (id != null) {
        return this.partSystemList.find(x => x.Id === id).Description;
    }
    return '';
  
  }
  getSioCodeName(id: number){
    if (id != null) {
        return this.sioCodeList.find(x => x.Id === id).Description;
    }
    return '';
  
  }
  getAllPEs() {        
    this.dataService
        .getPEs()
        .subscribe((response: any) => {
            if (response != null) {
                this.peList = response.Data;
            }
        });
        
  }
  getPackageEngineerName(id: number){
    if (id != null) {
        return this.peList.find(x => x.UserId === id).DisplayName;
    }
    return '';
  
  }
  ResetForm() {
    this.pe_addAssignmentForm.reset();
  }

  SioCodeChanged(siocode: SioCode[]) {
  }

  createRequestModel() {
    const siocode = this.getSioCode();
    const peAssignmentDTO = new PEAssignment();
    peAssignmentDTO.EngineerUserId = this.getPEId();
    peAssignmentDTO.SourceTypeId = this.getSourceTypeId();
    peAssignmentDTO.PartCategoryId = this.getpartSystemId();
    peAssignmentDTO.SupplierCode = this.getSupplierCode();
    peAssignmentDTO.PartNumber = this.getPartNumber();

    if (siocode && siocode.length > 0) {
      siocode.forEach(element => {
        const dto = Object.assign(new PEAssignment(), peAssignmentDTO);
        dto.SioCodeId = element;
        this.peAssignmentDTORequestList.push(dto);
        this.peAssignmentDTOList.push(dto);
      });
    }
    else {
      this.peAssignmentDTORequestList.push(peAssignmentDTO);
      this.peAssignmentDTOList.push(peAssignmentDTO);
    }
  }

  onSioCodeSearch(val) {
    if (!val || val.length <= 3) {
      this.getSioCodes();
      return;
    }
    else {
      this.sioCodeList = this.sioCodeList.filter(item => item.Description.toLowerCase().startsWith(val.toLowerCase()));
    }
  }

}
